import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';

import { AccountFileCommentForNotification } from '../graphql';
import AccountFilesRedirect from '../../../routing/AccountFiles/AccountFilesRedirect';
import FullScreenLoader from '../../FullScreenLoader';
import HeadOpenGraphMeta from '../../HeadOpenGraphMeta';
import { getThumbBySize } from '../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../constants/image-size-codes';

const propTypes = {
  accountFileComment: PropTypes.shape({
    id: PropTypes.string,
    parent: PropTypes.shape({
      id: PropTypes.string,
    }),
    video: PropTypes.shape({
      id: PropTypes.string,
    }),
    photo: PropTypes.shape({
      id: PropTypes.string,
      is_owner: PropTypes.bool,
      is_uploader: PropTypes.bool,
      albums: PropTypes.shape({
        records: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
          }),
        ),
      }),
    }),
  }),
};

const FileCommentItemRedirect = ({ loading, accountFileComment }) => {
  if (loading) {
    return <FullScreenLoader />;
  }

  const username = accountFileComment?.account?.username;

  return (
    <Fragment>
      {accountFileComment && (
        <HeadOpenGraphMeta
          title={`Comment by ${
            username ? `@${username}` : accountFileComment?.account?.name
          }`}
          imageUrl={
            getThumbBySize(
              accountFileComment?.photo?.thumbnail_urls,
              IMAGE_SIZE_CODE.MEDIUM2X,
            )?.url
          }
          videoUrl={accountFileComment?.video?.embed_url}
        />
      )}

      <AccountFilesRedirect
        loading={loading}
        photo={accountFileComment?.photo}
        video={accountFileComment?.video}
        searchQuery={{
          fileCommentId: accountFileComment?.id,
          parentFileCommentId: accountFileComment?.parent?.id,
        }}
      />
    </Fragment>
  );
};

FileCommentItemRedirect.propTypes = propTypes;

const withPhotoForNotification = graphql(AccountFileCommentForNotification, {
  props: ({ data: { accountFileComment, loading } = {}, ownProps }) => ({
    accountFileComment,
    loading: ownProps.loading || loading,
  }),
  options: ({ match }) => ({
    variables: {
      id: match.params.accountFileCommentId,
    },
    fetchPolicy: 'cache-and-network',
  }),
  skip: ({ match }) => !match.params.accountFileCommentId,
});

export default compose(
  withRouter,
  withPhotoForNotification,
)(FileCommentItemRedirect);
